import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { ResidentialService } from "../../shared/services/residential.service";
import { ResidentialResponse } from "../../shared/models/residential.model";

@Injectable({
    providedIn: 'root',
})
export class GetResidentialResolver implements Resolve<ResidentialResponse[]> {

    constructor(
        private residentialService: ResidentialService,
    ) { }

    resolve(): Observable<ResidentialResponse[]> {
        return this.residentialService.getAll();
    }
}
